const Employee = {

    // FIELDS
    "first_name": "الاسم الأول",
    "last_name": "الاسم الأخير",
    "dob": "تاريخ الميلاد",
    "gender": "الجنس",
    "father_name": "اسم الأب",
    "mother_name": "اسم الأم",
    "address": "العنوان",
    "postal_code": "الرمز البريدي",
    "phone_no": "رقم الهاتف",
    "mobile_no": "رقم الجوال",
    "status": "الحالة",
    "country": "الدولة",
    "state": "الولاية",
    "city": "المدينة",
    "search": "بحث",
    "user_type": "نوع المستخدم",
    "profile": "صورة الملف الشخصي",
    "isUser": "هل هو مستخدم",
    "license_no": "رقم الترخيص",
    "license_expiry": "تاريخ انتهاء الترخيص",
    "passport_no": "رقم الجواز",
    "passport_expiry": "تاريخ انتهاء الجواز",
    "visa_no": "رقم التأشيرة",
    "visa_issue": "تاريخ إصدار التأشيرة",
    "visa_expiry": "تاريخ انتهاء التأشيرة",
    "email": "البريد الإلكتروني",
    "basic": "أساسي",
    "driver": "سائق",
    "info": "معلومات",

    // PAGE HEADER
    "employee": "الموظف",

    // ERROR
    "error_first_name": "الرجاء إدخال الاسم الأول",
    "error_last_name": "الرجاء إدخال الاسم الأخير",
    "error_dob": "اختر تاريخ الميلاد",
    "error_gender": "الرجاء اختيار الجنس",
    "error_father_name": "الرجاء إدخال اسم الأب",
    "error_mother_name": "الرجاء إدخال اسم الأم",
    "error_address": "الرجاء إدخال العنوان",
    "error_postal_code": "الرجاء إدخال الرمز البريدي",
    "error_phone_no": "الرجاء إدخال رقم الهاتف",
    "error_mobile_no": "الرجاء إدخال رقم الجوال",
    "error_status": "الرجاء اختيار الحالة",
    "error_country": "الرجاء اختيار الدولة",
    "error_state": "الرجاء اختيار الولاية",
    "error_city": "الرجاء اختيار المدينة",
    "error_user_type": "يرجى تحديد نوع المستخدم",
    "error_profile": "يرجى اختيار الملف الشخصي",
    "error_isUser": "يرجى تبديل المستخدم",
    "error_license_no": "يرجى إدخال رقم الترخيص",
    "error_license_expiry": "يرجى اختيار تاريخ انتهاء الترخيص",
    "error_passport_no": "يرجى إدخال رقم الجواز",
    "error_passport_expiry": "يرجى اختيار تاريخ انتهاء الجواز",
    "error_visa_no": "يرجى إدخال رقم التأشيرة",
    "error_visa_issue": "يرجى اختيار تاريخ إصدار التأشيرة",
    "error_visa_expiry": "يرجى اختيار تاريخ انتهاء التأشيرة",
    "error_email": "يرجى إدخال البريد الإلكتروني",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_gender": "الجنس",
    "table_city": "المدينة",
    "table_mobile_no": "الجوال",
    "table_user_type": "نوع المستخدم",
    "table_is_user": "هل هو مستخدم",
    "table_status": "الحالة",
}

export default Employee;